import { Box, Paper, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { statusColors } from '../../constants';
import { InvoiceStatus } from '../../enums/invoiceStatus';
import { ProjectStatus } from '../../enums/projectStatus';
import { TalentStatus } from '../../enums/talentStatus';

interface Props {
  title: string;
  subtitle?: string;
  status?: ProjectStatus | InvoiceStatus | TalentStatus;
  children?: React.ReactNode;
}

const DetailsCard = (props: Props): JSX.Element => {
  return (
    <Paper sx={{ maxWidth: '1200px' }}>
      <Toolbar
        sx={{
          bgcolor: '#EEF0F7',
          py: 3,
          borderTopLeftRadius: '4px',
          borderTopRightRadius: '4px',
          justifyContent: 'space-between'
        }}
      >
        <Box>
          <Typography variant="h5" color="grey.900">
            {props.title}
          </Typography>
          <Typography>{props.subtitle}</Typography>
        </Box>
        {props.status && (
          <Box
            sx={{
              bgcolor: statusColors[props.status],
              color: 'text.primary',
              borderRadius: '20px',
              whiteSpace: 'nowrap',
              py: 1,
              px: 4
            }}
          >
            {props.status}
          </Box>
        )}
      </Toolbar>
      <Box sx={{ p: 3 }}>{props.children}</Box>
    </Paper>
  );
};

export default DetailsCard;
